module.exports = __webpack_public_path__ + "static/media/game-show-logo.10758a42.png";